import { AlertTriangle, CheckCircle2 } from "lucide-react";

const promises = [
  "Build your LinkedIn into a brand that signals expertise and trust",
  "Find and engage business owners actively looking for a finance partner",
  "Compound your authority through consistent, niche-focused content",
  "Deliver qualified discovery calls with prepared, real buyers",
];

const notPromises = [
  "Overnight magic or a flood of leads in week one",
  "Automated spam DMs that risk your account",
  "Generic 'agency' copy that sounds like everyone else",
  "Locked-in contracts or vague monthly reports",
];

export default function Honest() {
  return (
    <section
      id="honest"
      data-testid="honest-section"
      className="py-20 lg:py-28 border-b border-[#E4E4E7] bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mb-14 max-w-3xl">
          <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#1F4DA0] mb-4">
            The honest pitch
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
            This isn't magic. It's a system that compounds.
          </h2>
          <p className="mt-5 text-base text-[#52525B] max-w-2xl">
            Most "lead gen" agencies sell a fantasy: instant leads, no work, all upside. We don't. We build your brand on LinkedIn so that — month after month — the right business owners discover you, trust you, and reach out.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-[#09090B] border border-[#09090B]">
          <div className="bg-white p-8 lg:p-12">
            <div className="flex items-center gap-3 mb-6">
              <CheckCircle2 size={24} className="text-[#3FA742]" strokeWidth={2} />
              <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#09090B]">
                What we will do
              </p>
            </div>
            <ul className="space-y-4 mt-4">
              {promises.map((p) => (
                <li key={p} className="flex items-start gap-3 text-base text-[#09090B] leading-relaxed">
                  <span className="font-mono text-xs font-bold text-[#3FA742] mt-1.5 shrink-0">+</span>
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-[#09090B] text-white p-8 lg:p-12">
            <div className="flex items-center gap-3 mb-6">
              <AlertTriangle size={24} className="text-[#3FA742]" strokeWidth={2} />
              <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-white">
                What we won't do
              </p>
            </div>
            <ul className="space-y-4 mt-4">
              {notPromises.map((p) => (
                <li key={p} className="flex items-start gap-3 text-base text-white/85 leading-relaxed">
                  <span className="font-mono text-xs font-bold text-[#3FA742] mt-1.5 shrink-0">–</span>
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="mt-10 font-mono text-xs uppercase tracking-[0.25em] text-[#52525B] text-center">
          New clients are waiting on LinkedIn — your job is to be ready when they look.
        </p>
      </div>
    </section>
  );
}
